import { render } from "./OccasionBarChart.vue?vue&type=template&id=2cc766e0&scoped=true"
import script from "./OccasionBarChart.vue?vue&type=script&lang=js"
export * from "./OccasionBarChart.vue?vue&type=script&lang=js"

import "./OccasionBarChart.vue?vue&type=style&index=0&id=2cc766e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc766e0"]])

export default __exports__